import styled from '@emotion/styled';
import { Card, Tabs } from 'antd';

export const StyledCard = styled(Card)`
  margin: 30px;
  min-width: 600px;
`;

export const StyledHeader = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderSection = styled.div`
  padding: 24px 24px 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PageTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const BackLink = styled.div`
  margin-bottom: 16px;

  a {
    color: #00b9c6;
  }

  a:hover {
    color: #009aa5;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

export const BodySection = styled.div`
  padding: 0 24px 24px;
`;

export const ProfilesToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 24px;
`;

export const CompaniesTeamTabs = styled(Tabs)`
  .ant-tabs-nav .ant-tabs-tab {
    font-size: 16px;
    padding: 12px 16px;
  }

  .ant-tabs-bar {
    margin-bottom: 16px;
  }

  .ant-tabs-extra-content {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1;
  }
`;

export const UsersTableWrap = styled.div`
  overflow-x: hidden;

  .ant-table-body,
  .ant-table-content,
  .ant-table-scroll {
    overflow-x: hidden !important;
  }

  .ant-table table {
    width: 100% !important;
    table-layout: fixed;
  }

  .ant-table-expanded-row > td {
    padding: 0 !important;
    overflow: hidden !important;
    vertical-align: top;
    background: #fafafa;
  }
`;

export const CompactExpandedCompanies = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  max-height: 248px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;

  .expanded-companies-header,
  .expanded-companies-row {
    display: grid;
    grid-template-columns: 140fr 200fr 180fr 190fr 115fr 120fr 190fr;
    align-items: center;
    min-width: 0;
    max-width: 100%;
  }

  .expanded-companies-header {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
  }

  .expanded-companies-header a {
    color: #00b9c6;
  }

  .expanded-companies-header a:hover {
    color: #009aa5;
  }

  .expanded-companies-row {
    font-size: 13px;
    line-height: 1.35;
    border-bottom: 1px solid #f0f0f0;
  }

  .expanded-companies-row:last-child {
    border-bottom: none;
  }

  .expanded-companies-name {
    grid-column: 1 / 5;
    min-width: 0;
    padding: 6px 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .expanded-companies-meta {
    grid-column: 5 / 8;
    display: grid;
    grid-template-columns: 115fr 120fr 190fr;
    align-items: center;
    min-width: 0;
  }

  .expanded-companies-plan,
  .expanded-companies-sub,
  .expanded-companies-renewal {
    min-width: 0;
    padding: 6px 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ant-tag {
    margin: 0;
    padding: 0 6px;
    line-height: 18px;
    font-size: 12px;
  }
`;
